import React, { useState, useEffect } from "react";
import axios from "axios";
import { Flex } from "@chakra-ui/react";
import { TailSpin } from "react-loader-spinner";
import { API_URL } from "../../../constants";
import {getAuthToken} from "../../../helpers/helpers"

import HistoryItem from "views/admin/prodPlusVendus/components/HistoryItem";
import defaultImage from "assets/img/meds.png";
export default function Vendus() {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      const token = getAuthToken();

      try {
        const response = await axios.get(`${API_URL}/api/cart`, {
          headers: {
            "x-access-token": token,
            Authorization: `Bearer ${token}`,
          },
        });
        //console.log("cart", response.data);
        const nameCounts = response.data.reduce((acc, med) => {
          med.items.forEach((item) => {
            //console.log("test1", item.medicamentDetails);
            const itemName = item?.name;
            const itemImage = item.medicamentDetails?.photo;
            const itemPrice = item.medicamentDetails?.prix;
            const itemForme = item.medicamentDetails?.forme;
            const id = item.id
            const itemDate_peremption = item.medicamentDetails?.date_peremption

            if (Object.keys(acc).includes(itemName)) {
              acc[itemName].count += 1;
            } else {
              acc[itemName] = {
                count: 1,
                image: itemImage,
                price: itemPrice,
                forme: itemForme,
                id : id,
                date_peremption : itemDate_peremption
              };
            }
          });
          return acc;
        }, {});

        //console.log("nameCounts", nameCounts);
        const sortedNameCounts = Object.entries(nameCounts)
          .sort((a, b) => b[1].count - a[1].count)
          .slice(0, 10);
        //console.log("sorted", sortedNameCounts);
        const top10Products = sortedNameCounts.map(([name, details]) => ({
          name: name,
          image: details.image,
          price: details.count, // represents how many times a product is purchased
          forme: details.forme,
          id : details.id,
          date_peremption : details.date_peremption

        }));
        setProducts(top10Products);
        //console.log("top10", top10Products);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setProducts([]);
        } else {
          console.log("Error making the request:", error);
          setProducts([]);
        }
      } finally {
        setIsLoading(false);
      }
    }; 

    fetchData();
  }, []);
  return (
    <Flex
      flexDirection="column"
      py="70px"
      justifyContent={isLoading ? "center" : "flex-start"}
      alignItems={isLoading ? "center" : "stretch"}
      minHeight={isLoading ? "400px" : "auto"}
    >
      <div>
        {isLoading ? (
          <div style={{ textAlign: 'center' }}>
            <TailSpin
              height="120"
              width="120"
              color="#17254C"
              ariaLabel="tail-spin-loading"
              radius="1"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
            <p style={{ marginTop: '20px', color: '#17254C', fontSize: '16px' }}>
              Chargement des données
            </p>
          </div>
        ) : products.length > 0 ? (
          products.map((item, index) => (
            <HistoryItem
              key={index}
              name={item.name}
              image={item.image || defaultImage}
              price={item.price}
              forme={item.forme}
              date_peremption={item.date_peremption}
              id={item.id }
            />
          ))
        ) : (
          <p>Aucun élément à afficher</p>
        )}
      </div>
    </Flex>
  );
}
